import { AppBar, IconButton, Menu, MenuItem, Toolbar, Typography } from '@material-ui/core';
import { useState, useCallback } from 'react';
import { DefaultProfile } from '../../../images';
import Image from '../image/image';
import styles from './header.module.scss';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import { redirectTo } from 'utils';
import { Path, FleetStatus } from 'enums';
import { useContext } from 'react';
import { AppContext, FleetContext } from 'contexts';
import locale from 'localization';

const Header = () => {
  const [open, setOpen] = useState(false);
  const { toggleLoading } = useContext(AppContext);
  const { fleet = {} } = useContext(FleetContext) || {};
  const { status, businessName } = fleet || {};

  const logoutCb = useCallback(async () => {
    toggleLoading(true);
    localStorage.removeItem('accessToken');
    localStorage.removeItem('role');
    toggleLoading(false);
    redirectTo(Path.Auth);
  }, [toggleLoading]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <div id="header">
      <AppBar className={styles.headerContainer}>
        <Toolbar disableGutters>
          <div className={styles.logoContainer}>{/* <Image src={Logo} className={styles.logo} /> */}</div>
          <div className={styles.toolbarContainer}>
            <Typography variant="h6" className={styles.title}>
              {status === FleetStatus.Deactivated
                ? `${businessName} - (${locale.deactivated})`
                : `${businessName ? businessName : ''}`}
            </Typography>
            <div className={styles.menuContainer}>
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpen}
              >
                <Image src={DefaultProfile} className={styles.profile} />
                <KeyboardArrowDownRoundedIcon className={styles.caretIcon} />
              </IconButton>
              <Menu
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                keepMounted
                open={open}
                className={styles.menu}
                onClose={handleClose}
              >
                <MenuItem className={styles.menuItem} onClick={logoutCb}>
                  {' '}
                  Logout{' '}
                </MenuItem>
              </Menu>
            </div>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Header;
